import { render, staticRenderFns } from "./MoveProductions.vue?vue&type=template&id=494d7966&scoped=true&"
import script from "./MoveProductions.vue?vue&type=script&lang=js&"
export * from "./MoveProductions.vue?vue&type=script&lang=js&"
import style0 from "./MoveProductions.vue?vue&type=style&index=0&id=494d7966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d7966",
  null
  
)

export default component.exports